import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { DataTable, DeleteModal, Excel } from "CommonComponent";
import {
  fetchCategories,
  deleteCategory,
  getCategoryById,
  exportHandler,
} from "actions";
import AccessRights from "utils/AccessRights";
import { Columns, Header, Filter, AddUpdateCategories } from "./component";
import "./Categories.css";
import { useLocation } from "react-router-dom";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

const Categories = () => {
  let location = useLocation();
  const dispatch = useDispatch();
  const timeSheetCategoryState = useSelector(
    (state) => state.timeSheetCategoryState,
  );
  const session = useSelector((s) => s.session);

  const object_viewed_id = session?.current_page_permissions?.object_id || "";

  const [showAddUpdateModal, setShowAddUpdateModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [extraFiltersState, setExtraFiltersState] = useState({
    values: {},
  });

  useEffect(() => {
    if (
      session.current_page_permissions &&
      session.current_page_permissions.page_url === location.pathname
    ) {
      dispatch(
        fetchCategories({ ...extraFiltersState.values, object_viewed_id }),
      );
    }
  }, [session.current_page_permissions]);

  useEffect(() => {
    if (timeSheetCategoryState.redirectToList) {
      dispatch(
        fetchCategories({ ...extraFiltersState.values, object_viewed_id }),
      );
    }
  }, [timeSheetCategoryState.redirectToList]);

  useEffect(() => {
    if (timeSheetCategoryState.showUpdateForm) {
      setIsEdit(true);
      setShowAddUpdateModal(true);
    } else {
      setIsEdit(false);
      setShowAddUpdateModal(false);
    }
  }, [timeSheetCategoryState.showUpdateForm]);

  const handleAdd = () => {
    setIsEdit(false);
    setShowAddUpdateModal(true);
  };

  const handleEdit = (row) => {
    setSelectedRow(row);
    dispatch(getCategoryById(row.id, "update", object_viewed_id));
    setIsEdit(true);
    setShowAddUpdateModal(true);
  };

  const handleDelete = (row) => {
    setSelectedRow(row);
    setShowDeleteModal(true);
  };

  const confirmDelete = () => {
    dispatch(deleteCategory(selectedRow.id, object_viewed_id));
    setShowDeleteModal(false);
  };

  const getActions = (row) => (
    <div className="d-flex align-items-center gap-2">
      {AccessRights(session.current_page_permissions, "edit", row.created_by) &&
        row.is_deleted === "n" && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-edit-${row.id}`}>Edit</Tooltip>}
          >
            <img
              src="/assets/images/edit-icon.svg"
              alt="Edit"
              onClick={() => handleEdit(row)}
              style={{ cursor: "pointer", marginRight: "10px" }}
            />
          </OverlayTrigger>
        )}
      {AccessRights(
        session.current_page_permissions,
        "delete",
        row.created_by,
      ) &&
        row.is_deleted === "n" && (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id={`tooltip-delete-${row.id}`}>Delete</Tooltip>}
          >
            <img
              src="/assets/images/delete-icon.svg"
              alt="Delete"
              onClick={() => handleDelete(row)}
              style={{ cursor: "pointer" }}
            />
          </OverlayTrigger>
        )}
    </div>
  );

  const columns = Columns({ getActions, session });
  const rows = timeSheetCategoryState.categoriesList || [];

  const filterTable = () => {
    dispatch(
      fetchCategories({ ...extraFiltersState.values, object_viewed_id }),
    );
  };

  const handleExport = () => {
    dispatch(
      exportHandler(
        "timesheet/categories/export",
        extraFiltersState.values,
        object_viewed_id,
        "task_categories.xlsx",
      ),
    );
  };

  return (
    <div className="wrapper-div">
      <Header onAdd={handleAdd} />

      {/* Bread crumb or Filter */}
      <div className="d-flex justify-content-end align-items-center pb-4 px-4 position-sticky top-70 bg-white z-1">
        <div className="d-flex align-items-center gap-3">
          <Excel handleExport={handleExport} />
        </div>
      </div>
      <Filter
        onFilter={filterTable}
        extraFiltersState={extraFiltersState}
        setExtraFiltersState={setExtraFiltersState}
      />
      <DataTable
        columns={columns}
        data={rows}
        serverSide={false}
        showSearch={false}
        className="table-container"
      />
      {showAddUpdateModal && (
        <AddUpdateCategories
          show={showAddUpdateModal}
          onHide={() => setShowAddUpdateModal(false)}
          isEdit={isEdit}
          object_viewed_id={object_viewed_id}
        />
      )}

      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={() => confirmDelete()}
        message="Are you sure you want to delete this category?"
      />
    </div>
  );
};

export default Categories;
